"use client"

import { useState } from "react"
import { Instagram, Linkedin, Mail, Phone, X, Menu } from "lucide-react"
import { Link } from "react-router-dom"
import bookAdemoImg from "../resources/3646394.jpg"
import { postAws } from "../postAws"

export default function BookDemoPage() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    query: "",
  })
  const [showModal, setShowModal] = useState(false)
  const [isMenuOpen, setIsMenuOpen] = useState(false)

  const handleInputChange = (e) => {
    const { name, value } = e.target
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }))
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    console.log("Form Data:", formData)
    const demoData = postAws("https://api-dev.aurait.ai/demo", "POST", formData)
    setShowModal(true)
    setFormData({
      name: "",
      email: "",
      phone: "",
      query: "",
    })
  }

  return (
    <div className="flex flex-col items-center w-full min-h-screen justify-between">
      <header className="bg-white shadow-md rounded-md top-0 z-50 w-full py-2 opacity-95 flex justify-center">
        <div className="w-full px-4 sm:w-11/12 md:w-4/5 lg:w-3/4 flex items-center justify-between">
          <div className="logo-name">
            <Link to={"/"} className="flex items-center gap-2 py-2">
              <div>
                <h1 className="flex text-2xl sm:text-3xl font-semibold">
                  <span>पढ़.</span>
                  <span className="gradient-text font-semibold">AI</span>
                </h1>
              </div>
            </Link>
          </div>
          <div className="hidden md:flex gap-4 items-center">
            <Link
              to="/signup"
              className="border-gray-600 border-2 rounded-xl bg-white text-gray-800 font-semibold text-sm sm:text-lg py-1 px-3 sm:px-6 rounded"
            >
              Sign up
            </Link>
            <Link to="/login" className="gradient-border">
              <button className="bg-white text-gray-800 font-semibold text-sm sm:text-lg py-1 px-3 sm:px-6 rounded focus:outline-none focus:shadow-outline rounded-xl">
                Login
              </button>
            </Link>
          </div>
          <button className="md:hidden flex items-center p-2" onClick={() => setIsMenuOpen(!isMenuOpen)}>
            <Menu size={24} />
          </button>
        </div>
      </header>

      {isMenuOpen && (
        <div className="md:hidden w-full bg-white shadow-md py-2 px-4">
          <div className="flex flex-col space-y-2">
            <Link
              to="/signup"
              className="border-gray-600 border-2 rounded-xl bg-white text-gray-800 font-semibold text-center py-1 px-3"
            >
              Sign up
            </Link>
            <Link to="/login" className="gradient-border">
              <button className="w-full bg-white text-gray-800 font-semibold py-1 px-3 rounded focus:outline-none focus:shadow-outline rounded-xl">
                Login
              </button>
            </Link>
          </div>
        </div>
      )}

      <div className="container mx-auto px-4 py-8 w-full sm:w-11/12 md:w-4/5 lg:w-3/5 bg-white rounded-lg shadow-xl overflow-hidden my-8">
        <div className="flex flex-col md:flex-row gap-8 items-start">
          <div className="w-full md:w-1/2 h-full">
            <img src={bookAdemoImg || "/placeholder.svg"} alt="Book Demo" className="rounded-lg w-full h-auto" />
          </div>

          {/* Form Section */}
          <div className="w-full md:w-1/2">
            <h1 className="text-2xl sm:text-3xl font-semibold mb-4 text-left">Book a Demo</h1>
            <form onSubmit={handleSubmit} className="space-y-4">
              <div className="space-y-2">
                <label htmlFor="name" className="block font-medium text-left">
                  Name
                </label>
                <input
                  id="name"
                  name="name"
                  type="name"
                  placeholder="your name"
                  required
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                  value={formData.name}
                  onChange={handleInputChange}
                />
              </div>
              <div className="space-y-2">
                <label htmlFor="email" className="block font-medium text-left">
                  Email
                </label>
                <input
                  id="email"
                  name="email"
                  type="email"
                  placeholder="your@email.com"
                  required
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                  value={formData.email}
                  onChange={handleInputChange}
                />
              </div>
              <div className="space-y-2">
                <label htmlFor="phone" className="block font-medium text-left">
                  Phone Number
                </label>
                <input
                  id="phone"
                  name="phone"
                  type="tel"
                  placeholder="+1 (123) 456-7890"
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                  value={formData.phone}
                  onChange={handleInputChange}
                />
              </div>
              <div className="space-y-2">
                <label htmlFor="query" className="block font-medium text-left">
                  Your Query
                </label>
                <textarea
                  id="query"
                  name="query"
                  placeholder="How can we help you?"
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                  rows="4"
                  value={formData.query}
                  onChange={handleInputChange}
                ></textarea>
              </div>
              <button
                type="submit"
                className="w-full bg-blue-600 text-white font-medium py-2 px-4 rounded-md hover:bg-blue-700 transition duration-300"
              >
                Submit
              </button>
            </form>

            {/* Reach Us Section */}
            <div className="space-y-4 mt-6">
              <h2 className="text-xl sm:text-2xl font-semibold text-left">Reach Us</h2>
              <div className="flex justify-start space-x-4">
                <SocialIcon
                  Icon={Instagram}
                  href="https://instagram.com"
                  label="Instagram"
                  bgColor="bg-pink-600"
                  hoverColor="hover:bg-pink-700"
                />
                <SocialIcon
                  Icon={Linkedin}
                  href="https://linkedin.com"
                  label="LinkedIn"
                  bgColor="bg-blue-700"
                  hoverColor="hover:bg-blue-800"
                />
                <SocialIcon
                  Icon={Mail}
                  href="mailto:contact@example.com"
                  label="Email"
                  bgColor="bg-red-600"
                  hoverColor="hover:bg-red-700"
                />
                <SocialIcon
                  Icon={Phone}
                  href="tel:+11234567890"
                  label="Phone"
                  bgColor="bg-green-600"
                  hoverColor="hover:bg-green-700"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <footer className="bg-gray-800 text-white w-full">
        <div className="container mx-auto px-4 py-6">
          <div className="flex flex-col lg:flex-row justify-between items-center">
            <div className="flex gap-2 items-center mb-4 lg:mb-0">
              <span className="text-xl sm:text-2xl font-bold">Padhai </span>
              <span className="text-sm sm:text-lg font-medium">An AURA-AI Initiative</span>
            </div>
            <div className="text-center text-gray-400 mb-4 lg:mb-0">© 2025 Padhai. All rights reserved.</div>
            <nav>
              <ul className="flex flex-wrap justify-center space-x-4">
                <li>
                  <a href="#" className="hover:text-indigo-400 text-sm">
                    About
                  </a>
                </li>
                <li>
                  <a href="#" className="hover:text-indigo-400 text-sm">
                    Contact
                  </a>
                </li>
                <li>
                  <a href="#" className="hover:text-indigo-400 text-sm">
                    Privacy Policy
                  </a>
                </li>
                <li>
                  <a href="#" className="hover:text-indigo-400 text-sm">
                    Terms of Service
                  </a>
                </li>
              </ul>
            </nav>
          </div>
        </div>
      </footer>
      {/* Modal */}
      {showModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
          <div className="bg-white rounded-lg p-6 max-w-sm w-full">
            <div className="flex justify-between items-center mb-4">
              <h2 className="text-xl font-bold">We'll Reach out...Thanks!</h2>
              <button onClick={() => setShowModal(false)} className="text-gray-500 hover:text-gray-700">
                <X size={24} />
              </button>
            </div>
            <p>Contact Info updated. Our team will connect with you shortly.</p>
          </div>
        </div>
      )}
    </div>
  )
}

function SocialIcon({ Icon, href, label, bgColor, hoverColor }) {
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className={`flex h-10 w-10 sm:h-12 sm:w-12 items-center justify-center rounded-full ${bgColor} text-white transition-colors ${hoverColor}`}
      aria-label={label}
    >
      <Icon className="h-5 w-5 sm:h-6 sm:w-6" />
    </a>
  )
}

